import { useEffect } from "react";
import CountUp from "react-countup";

function CountUpInner({ countUpRef, start}) {
  useEffect(() => {
    start();
  }, [start]);

  return <span className="countUp" ref={countUpRef} />;
}

export default function Counter({end, duration}) {
  return (
    <CountUp end={end} duration={duration} startOnMount={false}>
      {({ countUpRef, start }) => (
        <CountUpInner countUpRef={countUpRef} start={start} />
      )}
    </CountUp>
  );
}